import React from 'react';
import {connect} from "react-redux";

import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import AuthService from "../../../../../services/AuthService";
import PerspectivesForm from './comps/PerspectivesForm';
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import AddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import {
    getEntretienHeader,
    getImpactPerspectives
} from './../../../../../actions/entreprise/actions_entreprise_entretien';
import Alert from "../../../../shared/utils/Alert";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import {Link} from "react-router-dom";

class Page3 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            poste_interesse_salarie: null
        };
        this.Auth = new AuthService();
        this.fetchImpactPerspectives = this.fetchImpactPerspectives.bind(this);
        this.deleteImpactPerspective = this.deleteImpactPerspective.bind(this);
        this.handleAddPosteInteret = this.handleAddPosteInteret.bind(this);
    }


    fetchImpactPerspectives() {
        const id_entretien = this.props.entretienHeader.id;
        this.props.dispatch(getImpactPerspectives(id_entretien));
        this.setState({poste_interesse_salarie: this.props.entretienHeader.poste_interesse_salarie})
    }

    deleteImpactPerspective(id_impact_perspective) {
        const id_entretien = this.props.entretienHeader.id;
        this.Auth.fetch(`/salarie/impact_perspectives/${id_entretien}/${id_impact_perspective}`, {
            method: 'delete'
        }).then(x => this.fetchImpactPerspectives());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.entretienHeader !== this.props.entretienHeader)
            this.fetchImpactPerspectives();

    }

    componentDidMount() {
        if (this.props.entretienHeader && this.props.entretienHeader.id)
            this.fetchImpactPerspectives();
    }

    handleAddPosteInteret() {
        const idEntretien = this.props.entretienHeader.id;
        this.Auth.fetch('/societe/entretien/poste_interesse_salarie/' + idEntretien, {
            method: 'PUT',
            data: {poste_interesse_salarie: this.state.poste_interesse_salarie}
        }).then(() => {
            this.props.dispatch(getEntretienHeader(idEntretien));
            window.alert('Ajouté avec succès.');
        });
    }


    render() {

        return (
            <div className={'row justify-content-md-center'}>
                <div className='col col-sm-10'>
                    <Alert
                        text="Veuillez décrire l'impact de l'évolution de l'entreprise sur le poste du salarié."/>
                    <table className="table table-sm">
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">Perspective d'évolution</th>
                            <th scope="col">Impact sur le poste du salarié</th>
                            <th scope="col">Échéance de l'impact</th>
                            <th scope="col">X</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.impact_perspectives.map(x => {
                            return (
                                <tr key={x.id}>
                                    <td>{x.perspective}</td>
                                    <td>{x.impact}</td>
                                    <td>{x.echeance}</td>
                                    <td>
                                        <DeleteIcon style={{cursor: 'pointer'}}
                                                    onClick={() => this.deleteImpactPerspective(x.id)} color='red'/>
                                    </td>
                                </tr>);
                        })}
                        </tbody>
                    </table>
                    <RaisedButton
                        label="Ajouter"
                        style={{marginTop: 15}}
                        onClick={() => this.setState({modalOpen: true})}
                        secondary={true}
                        icon={<AddIcon/>}
                    />
                    <div style={{marginTop: 20}}>
                        <Alert
                            text="Veuillez préciser ci-dessous la référence / l'intitulé du poste qu'intéresse le salarié pour une évolution professionnelle.">
                            Vous pouvez consulter l'ensemble des postes disponibles <Link target="_blank"
                                                                                          to='/entreprise/postes_disponibles'>ICI</Link>
                        </Alert>
                        <ValidatorForm
                            ref="form"
                            onSubmit={this.handleAddPosteInteret}
                        >
                            <TextValidator
                                value={this.state.poste_interesse_salarie}
                                onChange={(x, y) => this.setState({poste_interesse_salarie: y})}
                                type="text"
                                name='poste_interet'
                                validators={['required', 'trim']}
                                errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                floatingLabelText="Intitule / Référence du poste"
                            /><br/>
                            <RaisedButton
                                label="Ajouter"
                                style={{marginTop: 15}}
                                secondary={true}
                                type='submit'
                                icon={<AddIcon/>}
                            />
                        </ValidatorForm>
                    </div>
                    <Dialog
                        title="Perspectives d'évolution de l'entreprise / impact sur le métier du salarié"
                        modal={false}
                        open={this.state.modalOpen}
                        onRequestClose={() => this.setState({modalOpen: false})}
                        autoScrollBodyContent={true}
                    >
                        <PerspectivesForm/>
                    </Dialog>
                </div>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        entretienHeader: store.entretien.header,
        impact_perspectives: store.entretien.impact_perspectives
    }
}

export default connect(mapStateToProps)(Page3);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/Page3.js